import {getUrlWithVariant} from '../vendor/theme-scripts/theme-product-form';
import {changeContentBySelector} from '../vendor/theme-scripts/theme-product';
import {fetchProduct} from '../util/fetch-product';

const selectors = {
  gridSwatchFieldset: '[data-grid-swatch-fieldset]',
  input: '[data-swatch-input]',
  productItem: '[data-grid-item]',
  productInfo: '[data-product-information]',
  sectionId: '[data-section-id]',
  productImage: '[data-product-image]',
  swatchButton: '[data-swatch-button]',
  swatchLink: '[data-swatch-link]',
  swatchText: '[data-swatch-text]',
  template: '[data-swatch-template]',
  nativeScrollbar: 'native-scrollbar',
  tooltipElement: 'tooltip-component'
};

const classes = {
  visible: 'is-visible',
  hidden: 'hidden',
  stopEvents: 'no-events',
  swatch: 'swatch',
};

const attributes = {
  image: 'data-swatch-image',
  handle: 'data-swatch-handle',
  label: 'data-swatch-label',
  scrollbar: 'data-scrollbar',
  swatchCount: 'data-swatch-count',
  variant: 'data-swatch-variant',
  variantName: 'data-swatch-variant-name',
  variantTitle: 'data-variant-title',
  swatchValues: 'data-swatch-values',
  mobileColumnsSmall: 'data-mobile-columns-small',
  swatchImages: 'data-swatch-images'
};

class GridSwatch extends HTMLElement {
  constructor() {
    super();

    this.productItemMouseLeaveEvent = () => this.hideVariantImages();
    this.showVariantImageEvent = (swatchButton) => this.showVariantImage(swatchButton);
    this.resizeEvent = () => this.init();
  }

  connectedCallback() {
    this.handle = this.getAttribute(attributes.handle);
    this.nativeScrollbar = this.closest(selectors.nativeScrollbar);
    this.productItem = this.closest(selectors.productItem);
    this.productInfo = this.closest(selectors.productInfo);
    this.productImage = this.productItem.querySelector(selectors.productImage);
    this.template = document.querySelector(selectors.template).innerHTML;
    this.swatchesJSON = this.getSwatchesJSON();
    this.swatchesStyle = theme.settings.collectionSwatchStyle;
    document.addEventListener('theme:resize:width', this.resizeEvent);

    const label = this.getAttribute(attributes.label).trim().toLowerCase();

    fetchProduct(this.handle).then((product) => {
      this.product = product;
      this.colorOption = product.options.find(function (element) {
        return element.name.toLowerCase() === label || null;
      });

      if (this.colorOption) {
        this.init();
      }
    });
  }

  init() {
    this.innerHTML = '';
    this.count = 0;
    this.limitedCount = 0;
    this.swatches = this.colorOption.values;
    this.swatchesCount = 0;
    this.mobileSwatches = false;
    const maxSwatches = 2;

    if (this.getAttribute(attributes.mobileColumnsSmall) == 'true' && window.theme.isMobile() && (this.swatchesStyle == 'slider' || this.swatchesStyle == 'grid' || this.swatchesStyle == 'limited')) {
      this.mobileSwatches = true;
    }

    this.swatches.forEach((swatch) => {
      let variant = null;
      let variantAvailable = false;
      let image = '';

      for (const productVariant of this.product.variants) {
        const optionWithSwatch = productVariant.options.includes(swatch);

        if (!variant && optionWithSwatch) {
          variant = productVariant;
        }

        // Use a variant with image if exists
        if (optionWithSwatch && productVariant.featured_media) {
          image = productVariant.featured_media.preview_image.src;
          variant = productVariant;
          break;
        }
      }

      for (const productVariant of this.product.variants) {
        const optionWithSwatch = productVariant.options.includes(swatch);

        if (optionWithSwatch && productVariant.available) {
          variantAvailable = true;
          break;
        }
      }

      if (variant) {
        const swatchTemplate = document.createElement('div');
        swatchTemplate.innerHTML = this.template;
        const swatchButton = swatchTemplate.querySelector(selectors.swatchButton);
        const swatchLink = swatchTemplate.querySelector(selectors.swatchLink);
        const swatchText = swatchTemplate.querySelector(selectors.swatchText);
        const swatchHandle = this.swatchesJSON[swatch];
        // const swatchStyle = theme.settings.swatchesType == 'native' ? swatchHandle : `var(--${swatchHandle})`;
        const variantTitle = variant.title.replaceAll('"', "'");

        swatchButton.style = `--animation-delay: ${(100 * this.count) / 1250}s`;
        // swatchButton.classList.add(`${classes.swatch}-${swatchHandle}`);
        swatchButton.dataset.tooltip = swatch;
        swatchButton.dataset.swatchVariant = variant.id;
        swatchButton.dataset.swatchVariantName = variantTitle;
        swatchButton.dataset.swatchImage = image;
        swatchButton.dataset.variant = variant.id;
        swatchButton.style.setProperty('--swatch', swatchHandle);
        //swatchLink.href = getUrlWithVariant(this.product.url, variant.id);
        swatchButton.dataset.variantUrl = getUrlWithVariant(this.product.url, variant.id);
        swatchButton.dataset.variantPrice = variant.price;
        swatchLink.dataset.swatch = swatch;
        // swatchLink.disabled = !variantAvailable;
        swatchText.innerText = swatch;

        if (this.count === 0) {
          swatchButton.classList.add('active');
        }

        if (!this.mobileSwatches) {
          if (this.swatchesStyle != 'limited') {
            this.innerHTML += swatchTemplate.innerHTML;
          } else if (this.count <= 4) {
            this.innerHTML += swatchTemplate.innerHTML;
            this.limitedCount++;
          }
        } else if (this.count <= maxSwatches && this.mobileSwatches) {
          this.innerHTML += swatchTemplate.innerHTML;
          this.limitedCount++;
        }
        this.count++;
      }
      this.swatchesCount++;

      if (this.swatchesCount == this.swatches.length) {
        this.nativeScrollbar?.dispatchEvent(new Event('theme:swatches:loaded'));
      }
    });

    this.swatchCount = this.productInfo.querySelector(`[${attributes.swatchCount}]`);
    this.swatchElements = this.querySelectorAll(selectors.swatchLink);
    this.swatchFieldset = this.productInfo.querySelector(selectors.gridSwatchFieldset);
    this.hideSwatchesTimer = 0;

    if (this.swatchCount.hasAttribute(attributes.swatchCount)) {
      if (this.swatchesStyle == 'text' || this.swatchesStyle == 'text-slider') {
        this.swatchCount.innerText = `${this.count} ${this.count > 1 ? theme.strings.otherColor : theme.strings.oneColor}`;

        if (this.swatchesStyle == 'text') return;

        this.swatchCount.addEventListener('mouseenter', () => {
          if (this.hideSwatchesTimer) clearTimeout(this.hideSwatchesTimer);

          this.productInfo.classList.add(classes.stopEvents);
          this.swatchFieldset.classList.add(classes.visible);
        });

        // Prevent color swatches blinking on mouse move
        this.productInfo.addEventListener('mouseleave', () => {
          this.hideSwatchesTimer = setTimeout(() => {
            this.productInfo.classList.remove(classes.stopEvents);
            this.swatchFieldset.classList.remove(classes.visible);
          }, 100);
        });
      }

      if (this.swatchesStyle == 'slider' || this.swatchesStyle == 'grid') {
        this.swatchFieldset.classList.add(classes.visible);
      }

      if (this.swatchesStyle == 'limited' || this.count >= maxSwatches && this.mobileSwatches) {
        const swatchesLeft = this.count - this.limitedCount;

        this.swatchFieldset.classList.add(classes.visible);

        if (swatchesLeft > 0) {
          this.innerHTML += `<div class="swatch-limited">+${swatchesLeft}</div>`;
        }
      }
    }

    this.bindSwatchButtonEvents();
  }

  bindSwatchButtonEvents() {
    this.querySelectorAll(selectors.swatchButton)?.forEach((swatchButton) => {
      // Show variant image when hover on color swatch
      swatchButton.addEventListener('click', this.showVariantImageEvent);
    });

    //this.productItem.addEventListener('mouseleave', this.productItemMouseLeaveEvent);
  }

  showVariantImage(event) {
    const swatchButton = event.target.closest(selectors.swatchButton);
    if (!swatchButton) return;
    const swatchUrl = swatchButton.dataset.variantUrl;
    const productItemWrapper = swatchButton.closest('.product-item');
    const variantId = swatchButton.dataset.variant;
    const productItemUrls = productItemWrapper.querySelectorAll('.product-link');

    const variantName = swatchButton.getAttribute(attributes.variantName)?.replaceAll('"', "'");
    const variantImages = this.productImage.querySelectorAll(`[${attributes.variantTitle}]`);
    const variantImageSelected = this.productImage.querySelector(`[${attributes.variantTitle}="${variantName}"]`);

    productItemUrls?.forEach((productItemUrl) => productItemUrl.setAttribute('href', swatchUrl));

    // Hide all variant images
    variantImages?.forEach((image) => {
      image.classList.remove(classes.visible);
    });

    // Show selected variant image
    if (variantId) this.updateProductInfo(variantId, productItemWrapper);
    variantImageSelected?.classList.add(classes.visible);
    swatchButton.closest('.selector-wrapper__scrollbar').querySelectorAll(selectors.swatchButton).forEach((btn) => btn.classList.remove('active'));
    swatchButton.classList.add('active');
  }

  async updateProductInfo(id, wrapper) {
    const selectors = ['.badge-box-container', '.product-item__price__holder'];
    try {
      const response = await fetch(`/products/${this.handle}?variant=${id}&section_id=api-product-grid-item`);
      const responseText = await response.text();
      if (responseText) {
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        selectors.forEach(selector => changeContentBySelector(selector, wrapper, html));
      }
    } catch (e) {
      console.log(e, "updateProductInfo error");
    }
  }

  hideVariantImages() {
    // Hide all variant images
    this.productImage.querySelectorAll(`[${attributes.variantTitle}].${classes.visible}`)?.forEach((image) => {
      image.classList.remove(classes.visible);
    });
  }

  getSwatchesJSON() {
    if (!this.hasAttribute(attributes.swatchValues)) return {};

    // Splitting the string by commas to get individual key-value pairs
    const pairs = this.getAttribute(attributes.swatchValues).split(',');

    // Creating an empty object to store the key-value pairs
    const jsonObject = {};

    // Iterating through the pairs and constructing the JSON object
    pairs?.forEach((pair) => {
      const [key, value] = pair.split(':');
      jsonObject[key.trim()] = value.trim();
    });

    return jsonObject;
  }

  disconnectedCallback() {
    document.removeEventListener('theme:resize:width', this.resizeEvent);
  }
}

export {GridSwatch};
